import { useState } from 'react'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from 'reactstrap'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import '../css/di.css' // We'll need to add custom CSS


import PageHeader from './utils/PageHeader'
import ViewPackList from './ViewPackList'
import StoreDetails from './StoreDetails'
import Invoice from './Invoice'
import ViewInvoice from './ViewInvoice'
import EWayBill from './EWayBill'
import FocViewPackList from './FocViewPackList'
import FocViewInvoice from './FocViewInvoice'
import FocInvoice from './FocInvoice'
import ViewCRN from './ViewCRN'

const Store = () => {
  const [activeTab, setActiveTab] = useState('1')
  const userDetails = useSelector(store => store.user)

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  return (
    <div className='di-container'>
      <PageHeader
        pageName='INVENTORY'
        breadcrump1='Home'
        breadcrump2='Inventory'
        link='/dashboard'
      />

      <div className='p-3'>
        <div className='modern-tabs-wrapper'>
          <div className='modern-tabs-container'>
            <Nav className='modern-nav-tabs' tabs>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '1'
                  })}
                  onClick={() => toggle('1')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>🏬</span>
                    <span className='tab-text'>Store</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '2'
                  })}
                  onClick={() => toggle('2')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>📦</span>
                    <span className='tab-text'>Pack List</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '3'
                  })}
                  onClick={() => toggle('3')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>👁️</span>
                    <span className='tab-text'>View Invoice</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '4'
                  })}
                  onClick={() => toggle('4')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>👁️</span>
                    <span className='tab-text'>View CRN</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '5'
                  })}
                  onClick={() => toggle('5')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>📦</span>
                    <span className='tab-text'>FOC Pack List</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '6'
                  })}
                  onClick={() => toggle('6')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>👁️</span>
                    <span className='tab-text'>FOC View Invoice</span>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames('modern-nav-link', {
                    active: activeTab === '7'
                  })}
                  onClick={() => toggle('7')}
                >
                  <div className='tab-content-wrapper'>
                    <span className='tab-icon'>🧾</span>
                    <span className='tab-text'>Eway Bill</span>
                  </div>
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <TabContent activeTab={activeTab} className='modern-tab-content'>
          <TabPane tabId='1' className='fade-in'>
            <Row>
              <Col>
                <StoreDetails />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='2' className='fade-in'>
            <Row>
              <Col>
                <Invoice />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='3' className='fade-in'>
            <Row>
              <Col>
                <ViewInvoice />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='4' className='fade-in'>
            <Row>
              <Col>
                <ViewCRN />
              </Col>
            </Row>
          </TabPane>

          <TabPane tabId='5' className='fade-in'>
            <Row>
              <Col>
                <FocInvoice />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='6' className='fade-in'>
            <Row>
              <Col>
                <FocViewInvoice />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId='7' className='fade-in'>
            <Row>
              <Col>
                <EWayBill />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    </div>
  )
}

export default Store
